import React, { useState } from 'react';
import { Button, Modal, Spinner, Card, Badge, Container, Row, Col } from 'react-bootstrap';

const Owner = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [error, setError] = useState(null);

  const handleClick = async () => {
    setShowModal(true);
    setLoading(true);
    setResponseMessage('');
    setError(null);

    try {
      // Logic remains identical to your requirement
      const response = await fetch('https://iiuccsc-ctf.vercel.app/api/owner', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userType: 'guest' }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setResponseMessage(data.message || 'No message received');
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setResponseMessage('');
    setError(null);
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="border-0 shadow-lg overflow-hidden rounded-4">
            {/* Header with Cafe Branding */}
            <div className="bg-dark p-4 text-center text-white">
              <h2 style={{ fontFamily: "'Playfair Display', serif" }}>Staff Portal</h2>
              <p className="text-warning mb-0 small uppercase fw-bold" style={{ letterSpacing: '1px' }}>
                Management & Ownership Access
              </p>
            </div>

            <Card.Body className="p-4 text-center">
              <div className="mb-4">
                <i className="bi bi-shield-lock-fill text-muted" style={{ fontSize: '3rem' }}></i>
                <p className="text-muted mt-3">
                  This portal is intended for <strong>Campus Grind</strong> owners and administrators only. 
                  Unauthorized access attempts are logged.
                </p>
              </div>

              {/* Status Indicator */}
              <div className="bg-light p-3 rounded-3 mb-4 d-flex justify-content-between align-items-center">
                <span className="text-secondary fw-medium">Current Status:</span>
                <Badge bg="secondary" className="px-3 py-2">GUEST_USER</Badge>
              </div>

              <div className="text-start mb-4">
                <h6 className="fw-bold">Available Features:</h6>
                <ul className="text-muted small">
                  <li>View Cafe Revenue (Restricted)</li>
                  <li>Manage Employee Shifts (Restricted)</li>
                  <li>Access Ownership Flag (Restricted)</li>
                </ul>
              </div>

              <Button 
                variant="outline-dark" 
                className="w-100 py-2 fw-bold rounded-pill hover-elevate"
                onClick={handleClick}
              >
                Authenticate as Owner
              </Button>
            </Card.Body>
            <Card.Footer className="bg-white text-center py-3 border-0">
              <small className="text-muted">Session ID: {Math.random().toString(36).substring(7).toUpperCase()}</small>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      {/* Modern Response Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold">Authentication Result</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center pb-5 px-4">
          {loading ? (
            <div className="py-4">
              <Spinner animation="border" variant="warning" size="lg" />
              <p className="mt-3 text-muted fw-medium">Verifying Credentials...</p>
            </div>
          ) : error ? (
            <div className="py-3">
              <div className="text-danger mb-3" style={{ fontSize: '2rem' }}>⚠️</div>
              <p className="text-danger fw-bold">{error}</p>
            </div>
          ) : (
            <div className="py-3">
              <div className="mb-3">
                {responseMessage.includes("CyberCamp") ? (
                  <div style={{ fontSize: '3rem' }}>🎉</div>
                ) : (
                  <div style={{ fontSize: '3rem' }}>🚫</div>
                )}
              </div>
              <h5 className="mb-3 fw-bold text-dark">System Message:</h5>
              <div className="p-3 bg-light rounded-3 border">
                <code className="text-dark fs-6">{responseMessage}</code>
              </div>
              
              {!responseMessage.includes("CyberCamp") && (
                <p className="mt-4 text-muted small">
                  Error: Insufficient Privileges. <br/>
                  {/* Owner status could not be verified for <strong>userType: guest</strong>. */}
                </p>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center">
          <Button variant="dark" onClick={handleClose} className="px-5 rounded-pill">
            Acknowledge
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Owner;